import React from "react";
import { RotateCcw } from "react-feather";
import IconButton from "./IconButton";

export default function PresetInfo(props) {

  return (
    <div className="mt-20 u-d-flex u-flex-column u-align-center u-justify-center">
      <IconButton type="button" variant="danger" onClick={props.onClick}>
        <RotateCcw />
      </IconButton>
      <p className="u-d-block u-text-center notfound-text">Nenhum preset encontrado</p>
      <p className="u-d-block u-text-center">Adicione novos presets para conversar com seus clientes.</p>
    </div>
  );
}